// Validated categorical palette + role tokens (MCIP-13).
//
// These hexes are NOT chosen by taste — they are the reference palette's fixed slot
// order, validated with the dataviz validator for both modes:
//   light: CVD worst adjacent ΔE 9.1 · normal-vision worst 19.6 · 3 slots < 3:1 contrast
//   dark:  CVD worst adjacent ΔE 8.4 · normal-vision worst 19.3 · all slots >= 3:1
// The light-mode contrast WARN triggers the relief rule, which is why every chart
// ships visible labels AND a table view. Do not re-order or substitute a hex without
// re-running scripts/validate_palette.js on the new set.

/** Fixed slot order. Color follows the ENTITY, never its rank — filtering must not repaint. */
export const CLASSIFICATION_ORDER = ['product', 'test', 'environment', 'flaky', 'unknown'];

const SLOTS = {
  light: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4'],
  dark: ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181'],
};

/** classification → hex, stable across filters and modes. */
export function classificationColor(classification, mode = 'light') {
  const i = CLASSIFICATION_ORDER.indexOf(classification);
  const slots = SLOTS[mode] || SLOTS.light;
  return slots[i === -1 ? CLASSIFICATION_ORDER.length - 1 : i];
}

/** Single-series charts all use categorical slot 1 (each chart has only one series). */
export function seriesOne(mode = 'light') {
  return (SLOTS[mode] || SLOTS.light)[0];
}

/** Chart chrome + ink, per the reference palette's chrome table. */
export const CHROME = {
  light: {
    surface: '#fcfcfb',
    textPrimary: '#0b0b0b',
    textSecondary: '#52514e',
    muted: '#898781',
    grid: '#e1e0d9',
    axis: '#c3c2b7',
    deltaGood: '#006300',
    deltaBad: '#d03b3b',
  },
  dark: {
    surface: '#1a1a19',
    textPrimary: '#ffffff',
    textSecondary: '#c3c2b7',
    muted: '#898781',
    grid: '#2c2c2a',
    axis: '#383835',
    deltaGood: '#0ca30c',
    deltaBad: '#d03b3b',
  },
};

export function chrome(mode = 'light') {
  return CHROME[mode] || CHROME.light;
}

/** Read the mode the document is actually rendering in. */
export function currentMode() {
  if (typeof document === 'undefined') return 'light';
  const stamped = document.documentElement.getAttribute('data-theme');
  if (stamped === 'dark' || stamped === 'light') return stamped;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
